import { constants } from '@tradetrust-tt/token-registry-v4';

const supportInterfaceIds = constants.contractInterfaceId;

export { supportInterfaceIds };
